import CustomerInfoReadOnlyBlock, { CustomerInfoReadOnlyBlockProps } from './CustomerInfoReadOnlyBlock';

export type { CustomerInfoReadOnlyBlockProps };
export default CustomerInfoReadOnlyBlock;
